import { createSlice } from '@reduxjs/toolkit';

import {
  getSavedSalesChannelMapping,
  saveSalesChannelMapping,
} from '../salesChannels';

const createMappingEntry = () => ({
  status: 'idle',
  document: null,
  error: null,
});

const ensureEntry = (state, salesChannelId) => {
  if (!state.byId[salesChannelId]) {
    state.byId[salesChannelId] = createMappingEntry();
  }
  return state.byId[salesChannelId];
};

const salesChannelMappingsSlice = createSlice({
  name: 'salesChannelMappings',
  initialState: {
    byId: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSavedSalesChannelMapping.pending, (state, { meta }) => {
        const { salesChannelId } = meta.arg;
        const entry = ensureEntry(state, salesChannelId);
        entry.status = 'loading';
        entry.error = null;
      })
      .addCase(getSavedSalesChannelMapping.fulfilled, (state, { payload, meta }) => {
        const { salesChannelId } = meta.arg;
        const entry = ensureEntry(state, salesChannelId);
        entry.status = 'loaded';
        entry.document = payload || null;
        entry.error = null;
      })
      .addCase(getSavedSalesChannelMapping.rejected, (state, { error, meta }) => {
        const { salesChannelId } = meta.arg;
        const entry = ensureEntry(state, salesChannelId);
        entry.status = 'error';
        entry.error = error?.message || 'Failed to load sales channel mapping';
      })
      .addCase(saveSalesChannelMapping.fulfilled, (state, { payload, meta }) => {
        const { salesChannelId } = meta.arg;
        const entry = ensureEntry(state, salesChannelId);
        entry.status = 'loaded';
        entry.document = payload || null;
        entry.error = null;
      });
  },
});

export default salesChannelMappingsSlice.reducer;
